import React, { useEffect, useState } from "react";
import "./ScHeaderComp.css";
import AddToMemoryComp from "../../../../Navigation/memoryComps/AddToMemoryComp";
import iq_api_v2, { handleRefreshMem } from "../../../../../services/iqApiV2";
import { useParams, useSearchParams } from "react-router-dom";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";
import MemoryHistoryListComp from "../../../../Navigation/memoryComps/MemoryHistoryListComp";
import { useDispatch } from "react-redux";
import { listGlobalMemRequest } from "../../../../../store/features/actions/memory/globalMemoryActions";
import { useUser } from "../../../../../context/UserContext";
import ReviewComponent from "../../../../HtmlElements/ReviewComponent";
import { fetchReviewSectionEntityList } from "../../../../../services/commonService";
import { WSS_URL } from "../../../../../config/apiConfig";
import * as FeatherIcon from "react-feather";
import { useBanner } from "../../../../../context/BannerContext";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import usePortal from "../../../usePortal";



function ScHeaderComp({
  data,
  type = null,
  titlkey = "opportunity_name",
  titlTxt,
  showMoreModal,
  setShowMoreModal = () => {},
  opportunityId,
  tabConfig,
  showMemComp = false,
  memoryType,
  activeTab,
  onBackClick=()=>{},
  renderChild=null
}) {


  // console.log("tabConfig : ", tabConfig)
  // console.log("activeTab : ", activeTab)

  const { user } = useUser();
  const { accountName, clientName } = useParams();
  const [likeStatus, setLikeStatus] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [showDownloadBusinessCaseBtn, setShowDownloadBusinessCaseBtn] = useState(false);
  const [openAddmem, setOpenAddMem] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);

  const dispatch = useDispatch();
  const showBanner = useBanner();
  const { registerTask } = useTaskStatus();
  const [searchParams] = useSearchParams();

const renderPortal = usePortal(openAddmem, () => setOpenAddMem(false));


  useEffect(() => {
    if (!showMoreModal) {
      setOpenAddMem(false);
    }
  }, [showMoreModal]);

  useEffect(() => {
    if (openAddmem) {
      dispatch(listGlobalMemRequest({
        userId: user?.id,
        memoryType: "single-oportunity",
        opportunityId
      }));
    }
  }, [openAddmem]);

  useEffect(() => {
    setShowDownloadBusinessCaseBtn(activeTab?.includes("business_case"));
  }, [activeTab]);

  useEffect(() => {
    const fetchReviewData = async () => {
      if (type && opportunityId) {
        const like_list = await fetchReviewSectionEntityList(accountName, clientName, type, opportunityId);
        if (like_list?.[0]?.is_liked) {
          setLikeStatus(like_list[0].is_liked);
        }
      }
    };
    fetchReviewData();
  }, [type, opportunityId]);

  const handleRefreshMemory = async (e) => {
    e.preventDefault();
    setRefreshLoading(true);
    const resp = await handleRefreshMem({ opportunityId });
    setRefreshLoading(false);
    if (resp) {
      const wsEndpoints = {
        battle_card: "opp_sidecard_battle_card",
        business_case_slide: "opp_sidecard_business_case_slide",
        contact_map: "opp_sidecard_contact_map",
        news: "opp_sidecard_news",
        next_step: "opp_sidecard_next_step",
        value_selling_prompter: "opp_sidecard_value_selling_prompter"
      };
      Object.entries(wsEndpoints).forEach(([key, prefix]) => {
        if (resp?.[key]) {
          registerTask(`${prefix}_${opportunityId}`, `${WSS_URL}/${resp[key]}`);
        }
      });
    }
  };

  const downloadOpportunityCardData = async () => {
    try {
      setDownloadLoading(true);
      const response = await iq_api_v2.get(`/opportunities/generate_pdf`, {
        params: { opportunity_id: opportunityId, type },
        responseType: "blob"
      });

      const contentDisposition = response.headers["content-disposition"];
      let fileName = (titlTxt ? titlTxt : (data?.[titlkey] || "")) + ".pdf";
      const match = contentDisposition?.match(/filename="?(.+)"?/);
      if (match?.[1]) fileName = match[1];

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showBanner({ message: "File downloaded successfully!", title: "Alert", type: "success", duration: 10000 });
    } catch (error) {
      console.error("Error downloading PDF:", error);
      showBanner({ message: "Something went wrong. Please try later.", title: "Alert", type: "error", duration: 10000 });
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <div className="sc-card-header-wrapper" key={`side_card_head_${opportunityId}`}>
      <div className="back_arrow_name">
        <img src="/img/backArrow.png" className="back_arrow cursorP" onClick={() =>{ setShowMoreModal();onBackClick()}} />
        <div className="back_head_block">
          <h5 className="back_head">{titlTxt || data?.[titlkey]}</h5>
        </div>
      </div>

      <div className="right_side_btn_block">
        {type !== "incDS" || type!=="auto_nurture" && (
          <>
            <ReviewComponent reviewObj={{
              section: type,
              entity_code: opportunityId,
              entity_name: titlTxt || data?.[titlkey] || "",
              like_status: likeStatus,
            }} />
            {showDownloadBusinessCaseBtn && (
              <>
                <div className="divided_block"><span className="divided">|</span></div>
                <div className="thumbs_block">
                  {downloadLoading && <i className="fa fa-spinner fa-spin" style={{ fontSize: '15px', color: '#515258', marginRight: '5px' }}></i>}
                  <FeatherIcon.Download
                    className="fa"
                    style={{
                      width: '16px',
                      height: '17px',
                      marginRight: '7px',
                      color: '#515258',
                      cursor: downloadLoading ? 'not-allowed' : 'pointer',
                      opacity: downloadLoading ? 0.5 : 1
                    }}
                    onClick={!downloadLoading ? downloadOpportunityCardData : undefined}
                  />
                </div>
              </>
            )}
          </>
        )}
        {showMemComp && (
          <>
            <button className="memory_btn_trans" onClick={() => setOpenAddMem(true)}>
              <img src="/img/plus1.png" className="memory_icon" /> Memory
            </button>
            <button className="memory_btn" onClick={handleRefreshMemory}>
              <img src="/img/refresh.svg" className="memory_icon" />
              {refreshLoading ? <IOSSpinner /> : "Memory"}
            </button>
          </>
        )}
          {renderChild}
      </div>

      {renderPortal?.(
        <div style={{
          borderRadius: "1rem",
          boxShadow: "0 0.5rem 2rem rgba(0, 0, 0, 0.15)",
          zIndex: 1500,
          maxWidth: "30rem",
          maxHeight: "50rem",
          position: "fixed",
          top: "3.5rem",
          right: "6.5rem",
          overflow: "hidden"
          // when i click out side this, the portal should close
        }}>
          <AddToMemoryComp
            memoryType={memoryType}
            opportunityId={opportunityId}
            selectedChips={selectedChips}
            setSelectedChips={setSelectedChips}
            tabConfig={tabConfig}
          />
          <MemoryHistoryListComp memoryType={memoryType} />
        </div>
      )}
    </div>
  );
}

export default ScHeaderComp;
